"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * Builds a Contentful image url
 *
 * Contentful offers their [Images API](https://www.contentful.com/developers/docs/references/images-api/#/reference)
 * to make loading optimised images extremely easy.
 *
 * We combine the Contentful Images API with features from
 * [Next/Image](https://nextjs.org/docs/basic-features/image-optimization#loader)
 * to serve highly optimised images.
 *
 * @param {object} config
 * Configuration to initialise the URL.
 * Falls back to defaults when config values are not set.
 *
 * @param {string} config.src - Base URL for Contentful's image CDN
 *
 * @param {string} config.width - Width to fetch the image at
 *
 * @param {number} config.quality - Quality to fetch the image at
 *
 * @returns {string} - Contentful Image URL
 *
 */
var buildContentfulImageURL = function buildContentfulImageURL(_ref) {
  var src = _ref.src,
    width = _ref.width,
    quality = _ref.quality;
  var dropEmpty = function dropEmpty(object) {
    // eslint-disable-next-line no-unused-vars
    var filtered = Object.entries(object).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        _ = _ref3[0],
        v = _ref3[1];
      return v !== null && v !== undefined;
    });
    return Object.fromEntries(filtered);
  };
  var query = new URLSearchParams(dropEmpty({
    w: width,
    q: quality
  }));
  return "https:".concat(src, "?").concat(query.toString());
};
var _default = buildContentfulImageURL;
exports["default"] = _default;